// Central content source for the DSAeCommerce funnel.

export const EYEBROW = "7+ Years in Business — 400+ Clients — Official Amazon & Walmart Agency Partner";

export const HEADLINE_LINES = [
  "Now Accepting",
  "Clients for 2026 Q4",
  "— Limited Spots",
];

export const SUBHEAD =
  "If you owned a Done-For-You Amazon & Walmart business run by an official agency partner — stocked with the exact brands shoppers buy every single day — how much would that change your Q4?";

// Long authorized brand list (verbatim from client reference, order preserved).
export const BRANDS = [
  "Unilever", "Bounty", "Head & Shoulders", "Johnson & Johnson", "Crest",
  "Colgate", "Q-tips", "Tide", "Clean & Clear", "Oral-B", "Dawn", "P&G",
  "Nature Valley", "KitKat", "Hormel Foods", "Lay's", "Skippy", "Hershey",
  "Lean Cuisine", "Hunt's", "Snickers", "Reese's", "Häagen-Dazs", "Cheerios",
  "Kraft", "Betty Crocker", "Sara Lee", "Stouffer's", "General Mills",
  "Hot Pockets", "Oreo", "Quaker", "Dove", "Doritos", "Heinz", "M&M's", "Ritz",
];

export const TRUST_BADGES = [
  { label: "Official Amazon SPN Partner", icon: "ShieldCheck" },
  { label: "Walmart Solution Provider", icon: "BadgeCheck" },
  { label: "7+ Years · 400+ Clients", icon: "Clock" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "We source what already sells",
    body: "No untested private-label gambles. We place the household brands — Tide, Oreo, Dove, M&M's — that move off shelves every single day.",
  },
  {
    no: "02",
    title: "Official partner status, real leverage",
    body: "As an Official Amazon SPN Partner and Walmart Solution Provider, your store operates with credibility most sellers can never access.",
  },
  {
    no: "03",
    title: "Done-for-you, end to end",
    body: "Sourcing, listing, logistics, and scaling — handled by a team that has run this for 400+ clients across 7+ years.",
  },
  {
    no: "04",
    title: "Q4 is the window — and it's closing",
    body: "Holiday volume is where these stores earn. Spots for the 2026 Q4 cohort are strictly limited. First qualified, first placed.",
  },
];

export const REVIEW_COUNT = 143;
export const RATING_LABEL = "5-star rating based on 143 reviews";

export const TESTIMONIALS = [
  {
    quote:
      "I went from zero e-commerce experience to a fully stocked Amazon store carrying names I actually recognize. The team handled everything.",
    name: "Marcus R.",
    role: "Store owner · onboarded 2024",
  },
  {
    quote:
      "Being an official partner changed the game. Q4 was the best quarter I've ever had — and I barely lifted a finger.",
    name: "Danielle P.",
    role: "Store owner · onboarded 2023",
  },
  {
    quote:
      "143 reviews and counting for a reason. These are the only people I trust with a done-for-you build.",
    name: "Anthony V.",
    role: "Store owner · onboarded 2025",
  },
];

// External funnel targets (subdomains in production).
export const QUALIFICATION_CALL_URL = "https://lead.dsaecommerce.com/qualification-call";
export const TYPEFORM_ID = "01KEWJZ7C9KQH6ZFD6W5YPTMFQ";

// Public Typeform URL used as a fallback "open in new tab" link (with UTM params).
export const TYPEFORM_FALLBACK_URL =
  "https://form.typeform.com/to/duSffpUU?utm_source=xxxxx&utm_medium=xxxxx&utm_campaign=xxxxx&utm_term=xxxxx&utm_content=xxxxx";

// Official / verified partner badges.
export const PARTNER_BADGES = [
  { brand: "amazon", sub: "ads", tier: "Verified", tierColor: "#0E9D6E", accent: "#FF9900" },
  { brand: "Walmart", sub: "", tier: "Advertising", tierColor: "#0071DC", accent: "#FFC220" },
  { brand: "TikTok", sub: "Shop", tier: "Advanced", tierColor: "#EE1D52", accent: "#000000" },
];

// Authority stats bar.
export const STATS = [
  { value: "7+", label: "Years in business" },
  { value: "400+", label: "Clients served & counting" },
  { value: "$1.4B+", label: "Revenue managed for our clients" },
  { value: "3", label: "Marketplaces: Amazon, Walmart & eBay" },
];
